'use client'
import React, { useState } from 'react';
import Head from 'next/head'
import Image from 'next/image'
import Link from 'next/link';
import NavBarLanding from '@/components/NavBarLanding';
import Footer from '@/components/Footer';
import { SignFrom } from '@/components/Sign';

export default function Policies() {
    const [signValue, setSignValue] = useState<string>('signup');
    const [toggleSignForm, setToggleSignForm] = useState<boolean>(false);
    const PolitiqueDeConfidentialiteData = {
        "PDC": [
            {
                "article": "Introduction",
                "description": "La présente politique de confidentialité définit et vous informe de la manière dont Eurekia utilise et protège les informations que vous nous transmettez lorsque vous utilisez le présent site. Veuillez noter que cette politique de confidentialité est susceptible d’être modifiée ou complétée à tout moment par Eurekia, notamment en vue de se conformer à toute évolution législative, réglementaire, jurisprudentielle ou technologique."
            },
            {
                "article": "Visite du site",
                "description": "Il vous est possible de visiter le site de Eurekia sans communiquer aucune information personnelle vous concernant. Dans le cas d'une demande de contact, Eurekia peut être amené à vous demander de renseigner vos informations personnelles."
            },
            {
                "article": "Identité du responsable du traitement",
                "description": "Le responsable du traitement est la société Eurekia, dont vous trouvez plus d'informations sur la page des mentions légales."
            },
            {
                "article": "Finalités du traitement",
                "description": "Eurekia est susceptible de traiter vos informations personnelles aux fins de vous fournir les informations ou les services que vous avez demandé, de recueillir des informations nous permettant d’améliorer notre site, nos produits et services, et de pouvoir vous contacter à propos de différents évènements relatifs à Eurekia."
            },
            {
                "article": "Destinataires",
                "description": "Seul Eurekia est destinataire de vos informations personnelles. Ces informations, que ce soit sous forme individuelle ou agrégée, ne sont jamais transmises à un tiers."
            },
            {
                "article": "Durée de conservation",
                "description": "Vos informations personnelles sont conservées par Eurekia uniquement pour le temps correspondant à la finalité de la collecte qui ne saurait en tout état de cause excéder 24 mois."
            },
            {
                "article": "Droits Informatique et Libertés",
                "description": "Vous disposez des droits suivants concernant vos informations personnelles, que vous pouvez exercer en nous écrivant à l’adresse postale mentionnée dans les mentions légales."
            },
            {
                "article": "Droits d'accès et de communication des données",
                "description": "Vous avez la faculté d’accéder aux informations personnelles qui vous concernent."
            },
            {
                "article": "Droit de rectification des données",
                "description": "Au titre de ce droit, la législation vous habilite à demander la rectification, la mise à jour, le verrouillage ou encore l’effacement des données vous concernant."
            },
            {
                "article": "Droit d'opposition",
                "description": "L’exercice de ce droit n’est possible que dans certaines situations définies par la législation."
            },
            {
                "article": "Délais de réponse",
                "description": "Eurekia s’engage à répondre à votre demande d’accès, de rectification ou d’opposition ou toute autre demande complémentaire d’informations dans un délai qui ne saurait dépasser 1 mois à compter de la réception de votre demande."
            },
            {
                "article": "Plainte auprès de l'autorité compétente",
                "description": "Si vous considérez que Eurekia ne respecte pas ses obligations au regard de vos informations personnelles, vous pouvez adresser une plainte ou une demande auprès de l’autorité compétente."
            }
        ]
    }



    return (
        <>
            <Head>
                <title>Eurekia !</title>
                <meta name="description" content="Generated by webzh" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <link rel="icon" href="/favicon.ico" />
            </Head>

            <main className="w-full items-center justify-center flex-col bg-main overflow-x-hidden relative gap-4">
                {
                    toggleSignForm ?

                        <div className='w-full sm:h-full h-screen flex justify-center items-center'>
                            <style global jsx>{`
    #__next {
        height:100vh;
        width:100vw;
        overflow:hidden
      }
`}</style>
                            <div onClick={() => setToggleSignForm(false)} className='z-50 w-full h-full fixed top-0 left-0 flex justify-center items-center backdrop-blur-md bg-black bg-opacity-10'>
                            </div>
                            <div className='z-[1000] fixed flex justify-center'>
                                <SignFrom signValue={signValue} />
                            </div>
                        </div>
                        : null
                }
                < NavBarLanding
                    signValue={signValue as string}
                    setSignValue={setSignValue}
                    toggleSignForm={toggleSignForm}
                    setToggleSignForm={setToggleSignForm}
                />
                <section className="w-full flex flex-col items-center h-auto pt-[150px]">

                    <h1 className='font-medium text-3xl lg:text-[2.4vw] leading-tight flex sm:items-start items-center justify-center flex-col text-center'>
                        Conditions d'Utilisation
                    </h1>
                    <div className=" p-8 w-full max-w-3xl mx-auto rounded shadow-lg">
                        <h1 className="text-2xl font-bold mb-6">Politique de confidentialité de Eurekia</h1>

                        {PolitiqueDeConfidentialiteData.PDC.map((item, index) => (
                            <React.Fragment key={index}>
                                <h2 className="text-xl font-semibold mt-4 mb-4">{item.article}</h2>
                                <p className="mb-4">{item.description}</p>
                            </React.Fragment>
                        ))}

                    </div>
                </section>
                <Footer />

            </main>
        </>
    )
}
